// How an incident's recurring fields read on screen.
//
// These lived in pages/Incidents.jsx, which is still their main caller. They are
// out here because the incidents map's point dialog needs the same three, and
// importing them from the page would close the loop
// Incidents.jsx -> IncidentMap.jsx -> IncidentPointDialog.jsx -> Incidents.jsx,
// which webpack resolves to `undefined` at module-evaluation time rather than to
// an error you can read.
//
// None of them touches component state, so a row from any source can be labelled
// the same way the list labels it — which is the point: the map's dialog and the
// table must not describe the same incident differently.
//
// Note components/PatientIncidentHistory.jsx has its own copy of fmtDateTime.
// Leave it be; just don't add a fourth.

export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

// The same stamp without the seconds, e.g. "23/09/2026, 14:32" — for compact
// lists, where a second's precision is noise but the date is not: an event can
// run for a week, so two incidents at one aid station may read 14:32 and be
// days apart.
export const fmtDateTimeShort = (iso) =>
  (iso ? new Date(iso).toLocaleString([], { dateStyle: "short", timeStyle: "short" }) : "—");

// How an allocation reads. A team allocation stores the team's name in the same
// snapshot field a person's goes in, so say which it is.
export const allocatedLabel = (i) => {
  if (!i?.allocated_to_name) return "";
  return i.allocated_to_team_id != null ? `${i.allocated_to_name} (team)` : i.allocated_to_name;
};

// Patient as "race number - name" (whichever parts are present).
export const patientLabel = (i) =>
  [i.patient_race_number, i.patient_name].filter(Boolean).join(" - ") || "—";
